import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum Ethnicity {
  ASIAN = "asian",
  ASK_ME = "ask_me",
  BLACK = "black",
  LATINO = "latino",
  MIDDLE_EASTERN = "middle_eastern",
  MIXED = "mixed",
  OTHER = "other",
  SOUTH_ASIAN = "south_asian",
  WHITE = "white",
  INDIAN = "indian",
}

const ETHNICITY_ATTRIBUTE_VALUES: ReadonlyArray<AttributeValue> = [
  { id: Ethnicity.ASIAN, label: "Asian", iconLabel: "🌏" },
  { id: Ethnicity.ASK_ME, label: "Ask Me", iconLabel: "❓" },
  { id: Ethnicity.BLACK, label: "Black", iconLabel: "🌍" },
  { id: Ethnicity.LATINO, label: "Latino", iconLabel: "🌎" },
  { id: Ethnicity.MIDDLE_EASTERN, label: "Middle Eastern", iconLabel: "🕌" },
  { id: Ethnicity.MIXED, label: "Mixed", iconLabel: "🧬" },
  { id: Ethnicity.OTHER, label: "Other", iconLabel: "🌐" },
  { id: Ethnicity.SOUTH_ASIAN, label: "South Asian", iconLabel: "🛕" },
  { id: Ethnicity.WHITE, label: "White", iconLabel: "🏛️" },
  { id: Ethnicity.INDIAN, label: "Indian", iconLabel: "🕌" },
];

export const UserEthnicityAttributeSet: UserAttributeSet = {
  id: UserAttributeType.ETHNICITY,
  isMultiSelect: false,
  map: attributeListToMap(ETHNICITY_ATTRIBUTE_VALUES),
} as const;
